const DOWNLOAD_STATUSES = {
    pending: 0,
    in_progess: 1,
    finished: 2,
    failed: 3,
};
const EVENT_KEYS = [
    "exchange.transaction.create.completed",
    "gallery.duplicate.completed",
    "gallery.duplicate.failed",
    "media.delete.complete",
    "media.delete.failed",
    "media.download.progress",
    "media.update.failed",
    "conversation.comment.created",
    "bulk.payment.completed",
];
export { EVENT_KEYS, DOWNLOAD_STATUSES };
